import { render, staticRenderFns } from "./PriceList.vue?vue&type=template&id=320f4984"
import script from "./PriceList.vue?vue&type=script&lang=ts"
export * from "./PriceList.vue?vue&type=script&lang=ts"
import style0 from "./PriceList.vue?vue&type=style&index=0&id=320f4984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports